import { useEffect } from "react";

let activeLocks = 0;

function updatePageScrollLock() {
  if (activeLocks > 0)
    document.documentElement.setAttribute("data-page-scroll-locked", "");
  else document.documentElement.removeAttribute("data-page-scroll-locked");
}

export function usePageScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    activeLocks += 1;
    updatePageScrollLock();

    return () => {
      activeLocks = Math.max(0, activeLocks - 1);
      updatePageScrollLock();
    };
  }, [locked]);
}
